export const dataFeedPermissions = {
  pageId: 73,
  name: 'Data Feed Credits',
  path: '/data-feed-credit',
  sections: {},
} as const;
